// extracted by mini-css-extract-plugin
export default {"statusWrapper":"AccountStatusIndicator_statusWrapper__DAEJ4","statusText":"AccountStatusIndicator_statusText__WCGD2","statusDot":"AccountStatusIndicator_statusDot__R8Mnd"};